"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleDriveUploadFile = exports.googleDriveUploadFileResultSchema = exports.googleDriveUploadFileExportsSchema = exports.googleDriveUploadFileArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleDriveUploadFileArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('upload-file', zod_1.z.object({
    filePath: zod_1.z.string().describe('The url of the file we want to upload'),
}), true);
var googleDriveFileSchema = zod_1.z.object({
    kind: zod_1.z.string().describe('Identifies what kind of resource this is'),
    mimeType: zod_1.z.string().describe('The MIME type of the file'),
    name: zod_1.z.string().describe('The name of the file'),
    id: zod_1.z.string().describe('The id of this file'),
    cdnUrl: zod_1.z
        .string()
        .optional()
        .describe('A direct download CDN based link for the file, best for direct access outside of Google Drive'),
    googleDriveUrl: zod_1.z.string().optional().describe('The Google Drive URL for this file'),
});
exports.googleDriveUploadFileExportsSchema = zod_1.z.object({
    $filestash_uploads: zod_1.z.array(zod_1.z.object({ get_url: zod_1.z.string() })).nullish(),
});
exports.googleDriveUploadFileResultSchema = (0, common_1.PipedreamNodeResultSchema)(googleDriveFileSchema, exports.googleDriveUploadFileExportsSchema);
exports.googleDriveUploadFile = (0, common_1.createToolMetadata)({
    id: 'googleDriveUploadFile',
    displayName: 'Google Drive Upload File',
    displayDescription: 'Upload a file to Google Drive. Returns googleDriveUrl and cdnUrl.',
    category: 'integration',
    color: common_1.BRAND_COLORS.GOOGLE_DRIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_DRIVE),
    icon: 'google_drive',
    argsSchema: exports.googleDriveUploadFileArgsSchema,
}, exports.googleDriveUploadFileResultSchema);
